export const TYPE_ICONS = {
  Delivery: '🚴',
  Pickup: '🥡',
  'Dine-in': '🍽',
  Booking: '🗓',
};

export function fmtC(n) {
  return n < 0 ? `-$${Math.abs(n).toFixed(2)}` : `$${n.toFixed(2)}`;
}

export function fmtCA(n) {
  return `$${Math.abs(n).toFixed(2)}`;
}

export function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function fmtDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatPeriod(period) {
  if (!period?.from || !period?.to) return '';
  return `${fmtDate(period.from)} – ${fmtDate(period.to)}`;
}

export function computeTotals(orders) {
  return orders.reduce(
    (acc, o) => ({
      sub: acc.sub + (o.orderSubtotal ?? 0),
      pro: acc.pro + (o.promo ?? 0),
      adjAmt: acc.adjAmt + (o.adjustmentAmount ?? 0),
      sur: acc.sur + (o.venueCharges ?? 0),
      adj: acc.adj + (o.kraveinCharges ?? 0),
      sale: acc.sale + (o.saleValue ?? 0),
      fee: acc.fee + (o.kraveinFees ?? 0),
      pay: acc.pay + (o.netPayout ?? 0),
      del: acc.del + (o.deliveryFee ?? 0),
      cc: acc.cc + (o.creditCardFees ?? 0),
      amt: acc.amt + (o.orderTotal ?? 0),
      appFee: acc.appFee + (o.applicationFee ?? 0),
      kraveinPayout: acc.kraveinPayout + (o.kraveinPayout ?? 0),
    }),
    {
      sub: 0,
      pro: 0,
      adjAmt: 0,
      sur: 0,
      adj: 0,
      sale: 0,
      fee: 0,
      pay: 0,
      del: 0,
      cc: 0,
      amt: 0,
      appFee: 0,
      kraveinPayout: 0,
    },
  );
}

export const breakdownRows = order => [
  ['Subtotal (all items)', `$${(order.orderSubtotal ?? 0).toFixed(2)}`, 'var(--ink)'],
  ['Promo / Discount', (order.promo ?? 0) < 0 ? fmtC(order.promo) : '—', 'var(--rd)'],
  ['Adjustment', (order.adjustmentAmount ?? 0) !== 0 ? fmtC(order.adjustmentAmount) : '—', 'var(--or)'],
  [
    'Venue Charges',
    (order.venueCharges ?? 0) > 0 ? fmtCA(order.venueCharges) : '—',
    'var(--or)',
  ],
  ['Sale Value', `$${(order.saleValue ?? 0).toFixed(2)}`, 'var(--ink)'],
  ['KRAVEiN Fee', `-$${(order.kraveinFees ?? 0).toFixed(2)}`, 'var(--ink)'],
  ['Net Payout (incl. GST)', `$${(order.netPayout ?? 0).toFixed(2)}`, 'var(--ink)'],
  ['Kravein Fee GST', (order.kraveinFeeGst ?? 0) !== 0 ? fmtC(order.kraveinFeeGst) : '—', 'var(--ink)'],
];

export const kraveinRows = order => [
  ['KRAVEiN Charges', (order.kraveinCharges ?? 0) !== 0 ? fmtC(order.kraveinCharges) : '—'],
  ['Delivery Fee', (order.deliveryFee ?? 0) > 0 ? fmtCA(order.deliveryFee) : '—'],
  ['Credit Card Fee', fmtCA(order.creditCardFees ?? 0)],
];
